import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewContainerMasterModal = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    // Handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            console.log('Selected file:', file);
        }
    };

    // Trigger file input click when attachment button is clicked
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };
    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Container Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label>Container Type</label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label>Internal Volume </label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>

                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label>Max. Load Weight</label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label>Min. Fill Percentage </label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span></span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewContainerMasterModal;